const STORAGE_KEY = "teamCardBrandingOverrides";

export const getCardBrandingOverride = (cardId, uuid) => {
  if (typeof window === "undefined") return {};

  try {
    const overrides = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return overrides[String(cardId)] || overrides[String(uuid)] || {};
  } catch {
    return {};
  }
};

export const saveCardBrandingOverride = (cardId, uuid, values) => {
  if (typeof window === "undefined" || (!cardId && !uuid)) return;

  try {
    const overrides = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const existingOverride =
      overrides[String(cardId)] || overrides[String(uuid)] || {};
    const override = {
      ...existingOverride,
      ...Object.fromEntries(
      Object.entries(values).filter(([, value]) => value !== undefined)
      ),
    };

    if (cardId) overrides[String(cardId)] = override;
    if (uuid) overrides[String(uuid)] = override;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
  } catch {
    // A storage failure must not prevent the card itself from being saved.
  }
};
